/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import DailyClosingEvent from '../../event/DailyClosingEvent'
import { DailyClosingHeadState } from '../state/DailyClosingHeadState'

class DailyClosingHeadsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case DailyClosingEvent.dateChange:
      case DailyClosingEvent.fetchBySearchCondition:
        const heads = payload.result.map(head => {
          return new DailyClosingHeadState().mergeModel(head)
        })
        return List(heads)
      default:
        return state
    }
  }
}

export default new DailyClosingHeadsStore()
